<template>
    <v-card elevation="5" outlined shaped>
        <v-dialog v-model="normasModal" max-width="600" class="text-cenet">
            <v-card elevation="5" outlined shaped>
              <v-list-item>
                <v-list-item-title class="text-center">
                  <h4>LA NUEVA CONTRASEÑA NO ES SEGURA...</h4>
                  <h5>1.- DEBE TENER AL MENOS 8 CARACTERES</h5>
                  <h5>2.- DEBE INCLUIR MAYUSCULAS,MINUSCULAS Y NUMEROS</h5>
                  <h5>3.- DEBE INCLUIR UN SIMBOLO ESPERICAL(@$!%*?&)</h5>
                </v-list-item-title>
              </v-list-item>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="12">
      
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-row align="center" justify="space-around">
                 
                      <v-btn class="mx-2" fab dark small color="#EE680B" @click="closedeltoma()" style="float: right"
                        title="CANCELAR">
                        <v-icon dark> mdi-close-circle-outline </v-icon>
                      </v-btn>
                    </v-row>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
      <div>
        <v-alert dense color="#EE680B" style="color: #ffffff">
          <h5>CAMBIAR CONTRASEÑA</h5>
        </v-alert>
      </div>
      <div>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-row>

               
                <v-col cols="12" md="3"> 
                 <v-text-field
                    v-model.trim="pwd"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required]"
                    :type="show1 ? 'text' : 'Password'"
                    name="input-10-1"
                    label="CONTRASEÑA ACTUAL"
                    
                    outlined
                    dense
                    counter
                    @click:append="show1 = !show1"
                  ></v-text-field>
              </v-col>
                <v-col cols="12" md="9"> </v-col>
              <v-col cols="12" md="3"> 
                <v-text-field
                     v-model.trim="npwd"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required]"
                    :type="show2 ? 'text' : 'Password'"
                    name="input-10-1"
                    label="NUEVA CONTRASEÑA"
                    
                    outlined
                    dense
                    counter
                    @click:append="show2 = !show2"
                  ></v-text-field>
              </v-col>
                
  
               
                

           
              <v-col cols="12" md="12">
                <v-toolbar dense shaped color="#002245">
                  <v-toolbar-title style="color: #ffffff">
                    <h6>OPCIONES</h6>
                  </v-toolbar-title>

                
                  <v-btn 
                  rounded
                  color="#EE680B"
                  class="ma-2 white--text"
                  @click="registrarBajacontraseña()"
                >
                GUARDAR NUEVA CONTRASEÑA
                  <v-icon
                    right
                    dark
                  >
                  mdi-check-circle-outline
                  </v-icon>
                </v-btn>
                </v-toolbar>
              </v-col>
  
  
  
  
  
  
  
            </v-row>
          </v-container>
        </v-form>
      </div>
  
    
  
  
  
      <div class="text-center">
        <v-snackbar v-model="snackbarOK" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
          <strong>{{ mensajeSnackbar }}</strong>
  
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarOK = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
      </div>
      
  
    </v-card>
  </template>
    <script>
    import axios from "axios"
    import VueHtml2pdf from 'vue-html2pdf'
    export default {
      data() {
        return {
          referencia1:'TRANSFERENCIA DE PAGOS',
          referencia:'',
          referencia2:"TIPO DE BECA",
          referenciacpp:'CAMBIO DE PLAN DE ECONOMICO',
          datosRecursado:'',
          pwd:'',
          npwd:'',
          cnpwd:'',
          recursada:'N',
          hoy: "",
          fechaEntrega: "",
          tipoInscripcion: "WEBADM",
          mat: "",
          pat: "",
          nomest:"",
          id_estudiante: "",
          unicodigo: "",
          num_documento: "",
          paterno: "",
          materno: "",
          nombres: "",
          nombreCompleto: "",
          datosCarrera: [],
          idPlanestudio: "",
          idCarrera: "",
          datosvigenciaBac:[],
          carrera: "",
          menuIni:0,
          menuIni1fac:0,
          menuIni1:0,
          menuIni2:0,
          menuIni9:0,
          menuIni6:0,
          gestion: "",
          gestiontrans2:"",
          idGestion: "",
          datosOfertaMaterias: [],
          idMateria: "",
          detalleModal: 0,
          datosCantidadEstGrupo: [],
          datostransGestion:[],
          gestiontransModal:"",
          datosGruposInscripcion: [],
          idTurno: "",
          datosTurno: [],
          turno: "",
          urlFoto: "",
          addtransferencia:"",
          idGrupoDocente: "",
          idTipoModalidad: 1,
          modalidad: "",
          paralelo: "",
          capacidad: "",
          tipoGrupo: "",
          idGestiontrans:"",
          idNivel: "",
          idUsuario: 6,
          idPlanEconomico: "",
          yaInscrito: false,
          cantidadMaximaMaterias: 7,
          //maxMateriasPreinscritas: 0,
          cantidadActualMaterias: "",
          datosGruposPreInscripcion: [],
          idNota: "",
          minimoNivel: "",
          datosOfertaMateriasNivel: [],
          idGrupoAux: "",
          descripnuevoplaneco:"",
    
    
          //tipo: "PRACTICO",
          observacionModal: 0,
          EliminartomaModal:0,
          EliminartomaindividualModal:0,
          desacttomaModal:0,
          acttomaModal:0,
          //CREAR AQUI
          observacion:"",
          resolucion:"",
          fechaResolucion:"",
  
          resoluciontrans:"",
          fechaResoluciontrans:"",
          fechafac:"",
          observaciontrans:"",
          nuevaResoluciontrans:"",
          nuevaObservaciontrans:"",
          
  
          resolucionobs:"",
          fechaResolucionobs:"",
          observacionobs:"",
          nuevaResolucionobs:"",
          nuevaObservacionobs:"",
  
  
          resolucioncamb:"",
          fechaResolucioncamb:"",
          observacioncamb:"",
          nuevaResolucioncamb:"",
          nuevaObservacioncamb:"",
          idItemfac:"",
  
          normasModal: 0,
          obserbacModal:0,
          datosObsbac:[],
          datosGestioninicial:[],
          datosHorario: [],
          idFranjaHoraria: "",
          idDia: "",
          cantAct: "",
          datosCantidadEspacio: [],
          datosHorariosGrupo: [],
          datosBecas: [],
          //datosHorarioConvertido: [LUNES, MARTES, MIERCOLES, JUEVES, VIERNES, SABADO, DOMINGO],
          tienePractico: "FALSE",
    
          choqueHorario: 0,
          idGrupoPadre: "",
          esCompartido: "",
          kardexModal: 0,
          datositems: [],
          choquecant: 0,
          searchPagos:"",
          search: "",
          inpNum: "",
          id_docente: "",
          matricula:"",
          tipodocente: "",
          searchDocente: "",
          selectGenero: "",
          datosGenero: ["FEMENINO", "MASCULINO"],
          auxmat: "",
          auxpat: "",
          auxnomest:"",
          uniest: "",
          datosOfertaCorregido: [],
          datosCantMateriasEst: [],
          datosEstudiante: [],
          datosGestion: [],
          datosDeuda: [],
          datosDeudaObservacion:[],
          datosGruposInscripcionPracticos: [],
          est: "",
          elModal: 0,
          carreraModal: 0,
          gestionModal: 0,
          gestioniniModal: 0,
          gestionfinModal: 0,
          turnoModal: 0,
          horarioModal1: 0,
          itemscuotasModal: 0,
          itemscuotasfacturaModal: 0,
          datosNivelesPreinscritos: [],
          datositemsfactura:[],
          nivelMaximoPreInscrito: "",
    
          itencant: 0,
          doble: 0,
          itemcantidadModal: 0,
          EliminaritemModal:0,
          deleteDialog: 0,
          oldNum: "",
          iditemdet: "",
          iditemdet1: "",
          idItem:"",
          totaldet: "",
          idtrans: "",
          busest: "",
          idcategoriaest: "",
          categoriaest: "",
          tiponacional: "",
          paisest: "",
          show1: false,
        show2: false,
        show3: false,
        show4: false,
        password: 'Password',
        rules: {
          required: value => !!value || 'REQUERIDO.',
          min: v => v.length >= 8 || 'MINIMO 8 CARACTERES',
          emailMatch: () => (`..`),
          },
          snackbarOK: false,
          mensajeSnackbar: "",
          mensajeSnackbarGrupoLleno: "GRUPO LLENO",
          mensajeSnackbarNivel: "AÚN TIENE MATERIAS DE NIVEL INFERIOR",
          mensajeSnackbarHorario: 'CHOQUE DE HORARIO',
          mensajeSnackbarCantidadMaximaMaterias: 'CANTIDAD MAXIMA DE MATERIAS TOMADAS',
          mensajeSnackbarQuitarMateriaNivel: "PRIMERO QUITE MATERIAS DE NIVEL SUPERIOR",
          mensajeSnackbarDocumentos: "REGULARICE SU DOCUMENTACIÓN",
          snackbarError: false,
          snackbarError1: false,
          snackbarError2: false,
          snackbarError3: false,
          snackbarError4: false,
          mensajeError: "",
    
          timeout: 2000,
    
          alert: { show: false, message: "" },
          alertdocumento: { show: false, message: "" },
    
    
          headersTurno: [
    
            { text: "TURNO", value: "turno", sortable: true },
            { text: "OPCIONES", value: "actions", sortable: false },
          ],
          becaModal:0,
          planespagosModal:0,
          idbecdel:"",
          confirDeleteBecaModal:0,
          descripbeca:"",
          idbec:"",
        
          datostipobeca:[],
          datostieneins:[],
          datosTomamateria:[],
          pordesbec:0,
          montodesbec:0,
          resolbec:"",
          detallebec:"",
          headersbeca: [
            { text: "DESCRIPCION", value: "descip", sortable: true },
            { text: "OPCIONES", value: "actions", sortable: false }
          ],
          descripitem:"",
          descripitemfac:"",
          montoitem:0,
          montoitemfac:0,
          numfactura:0,
          searchnewitem:"",
          searchnewitemfac:"",
          headersitems: [
            { text: "ITEM", value: "item", sortable: true },
           // { text: "PRECIO", value: "precio", sortable: true },
           // { text: "OPCIONES", value: "actions", sortable: false },
          ],
          headersitemsfac: [
            { text: "ITEM", value: "item", sortable: true },
           // { text: "PRECIO", value: "precio", sortable: true },
           // { text: "OPCIONES", value: "actions", sortable: false },
          ],
          headersBecas: [
            { text: "BECA", value: "descript", sortable: false , class: 'my-header-style' },
            { text: "RESOLUCION", value: "resolu", sortable: false, class: 'my-header-style'  },
            { text: "DETALLE", value: "deta", sortable: false, class: 'my-header-style'  },
            { text: "%", value: "porce", sortable: false , class: 'my-header-style' },
            { text: "MONTO DESCUENTO(Bs)", value: "mont", sortable: false, class: 'my-header-style'  },
            { text: "FECHA", value: "fecha", sortable: false }
            
    
          ],
          headersObsbac: [
            { text: "GESTION", value: "gesti", sortable: false },
            { text: "OBSERVACIONES", value: "obs", sortable: false },
          ],
          headersplanespagos: [
            { text: "PLAN DE PAGOS", value: "nom", sortable: false },
            { text: "OPCIONES", value: "actions", sortable: false },
            
    
          ],
          headersCarrera: [
    
            { text: "CARRERA", value: "carre", sortable: true },
            { text: "OPCIONES", value: "actions", sortable: false },
          ],
          headersCantidadEstGrupo: [
    
            { text: "GRUPO", value: "idgru", sortable: true },
            { text: "PATERNO", value: "pat", sortable: true },
            { text: "MATERNO", value: "mat", sortable: true },
            { text: "NOMBRE", value: "nomb", sortable: true },
            { text: "ESTUDIANTES INSCRITOS", value: "cant", sortable: true },
            { text: "OPCIONES", value: "actions", sortable: false },
          ],
          headersGrupoInscripcion: [
            { text: "FECHA", value: "31-06-2023", sortable: true },
            { text: "FACTURA", value: "2525", sortable: true },
            { text: "MONTO", value: "780", sortable: true },
            { text: "PAGADO EN ", value: "PAGO ON LINE LIBELULA", sortable: true },
            
            //{ text: "OPCIONES", value: "actions", sortable: false },
          ],
          headersGrupoInscripcionPracticos: [
            { text: "GRUPO", value: "gru", sortable: true },
            { text: "DOCENTE", value: "doce", sortable: true },
            { text: "NIVEL", value: "idnv", sortable: true },
            { text: "CUPO", value: "cup", sortable: true },
            { text: "MODALIDAD", value: "modalidad", sortable: true },
            { text: "TURNO", value: "tu", sortable: true },
            { text: "TIPO DE GRUPO", value: "tpgru", sortable: true },
            //{ text: "ESTADO", value: "est", sortable: true },
            { text: "OPCIONES", value: "actions", sortable: false },
          ],
          headersGrupoPreInscripcion: [
            { text: "PARALELO", value: "gru", sortable: true },
            { text: "MATERIA", value: "mate", sortable: true },
            { text: "DOCENTE", value: "doce", sortable: true },
            { text: "NIVEL", value: "idnv", sortable: true },
            //{ text: "CUPO", value: "cup", sortable: true },
            { text: "MODALIDAD", value: "modalidad", sortable: true },
            { text: "TURNO", value: "tu", sortable: true },
            { text: "TIPO DE GRUPO", value: "tpgru", sortable: true },
            //{ text: "ESTADO", value: "est", sortable: true },
            { text: "OPCIONES", value: "actions", sortable: false },
          ],
          headersDeuda: [
    
    
            { text: "PLAN ECONOMICO", value: "planeconom", sortable: false, class: 'my-header-style'},
            { text: "CONCEPTO", value: "item", sortable: false , class: 'my-header-style'  },
            { text: "MONTO A COBRAR(Bs)", value: "deuda", sortable: false, class: 'my-header-style'  },
            { text: "DESCUENTO(Bs)", value: "montodes", sortable: false , class: 'my-header-style' },
            //{ text: "TOTAL(Bs)", value: "totales", sortable: false },
            { text: "OPCIONES", value: "actions", sortable: false },
          ],
          headersBAC: [ 
            { text: "PLAN ECONOMICO", value: "plannom", sortable: false, class: 'my-header-style'},
            { text: "GESTION INICIO", value: "gini", sortable: false , class: 'my-header-style'  },
            { text: "GESTION FINAL", value: "gfin", sortable: false, class: 'my-header-style'  },
            { text: "OPCIONES", value: "actions", sortable: false },
          ],
          headersObservacion1: [
            { text: "FECHA DE REGISTRO", value: "registrado", sortable: false, class: 'my-header-style'  },
            { text: "CATEGORIA", value: "categ", sortable: false, class: 'my-header-style'  },
            { text: "RESOLUCION", value: "resol", sortable: false, class: 'my-header-style'  },
            { text: "FECHA RESOLUCION", value: "fecha", sortable: false , class: 'my-header-style' },
            { text: "OBSERVACION", value: "observ", sortable: false, class: 'my-header-style'  },
            //{ text: "TOTAL(Bs)", value: "totales", sortable: false },
            { text: "OPCIONES", value: "actions", sortable: false }
          ],
          headersObservacion2: [
            { text: "FECHA DE REGISTRO", value: "registrado", sortable: false },
            { text: "CATEGORIA", value: "categ", sortable: false },
            { text: "RESOLUCION", value: "resol", sortable: false },
            { text: "FECHA RESOLUCION", value: "fecha", sortable: false },
            { text: "OBSERVACION", value: "observ", sortable: false }
          ],
          datosobsdeuda:[],
          headersObservacion: [
            { text: "OBSERVACION", value: "obser", sortable: true },
            { text: "FECHA", value: "fechareg", sortable: true }
            
          ],
          headersGestion: [
    
            { text: "GESTION", value: "nom", sortable: true }
           // { text: "OPCIONES", value: "actions", sortable: false },
          ],
          headersGestioninicial: [
    
            { text: "GESTION", value: "nom", sortable: true }
           // { text: "OPCIONES", value: "actions", sortable: false },
          ],
          headersGestionfin: [
            
            { text: "GESTION", value: "nom", sortable: true }
          // { text: "OPCIONES", value: "actions", sortable: false },
          ],
          datosGestioninicial:[],
          datosGestionfin:[],
          headersGestiontrans: [
            
            { text: "GESTION", value: "nom", sortable: true },
            { text: "OPCIONES", value: "actions", sortable: false },
          ],
  
          headersEstudiante: [
            { text: "UNICODIGO", value: "unicod", sortable: true, class: 'my-header-style' },
            { text: "MATRICULA", value: "matr", sortable: true, class: 'my-header-style' },
            { text: "PATERNO", value: "pat", sortable: false, class: 'my-header-style' },
            { text: "MATERNO", value: "mat", sortable: false, class: 'my-header-style' },
            { text: "NOMBRES", value: "nom", sortable: false, class: 'my-header-style' },
            { text: "CARRERA", value: "carre", sortable: false, class: 'my-header-style' }
           // { text: "OPCIONES", value: "actions", sortable: false },
          ],
          headersKardex: [
    
            { text: "GESTION", value: "gest", sortable: true, class: 'my-header-style'  },
            { text: "SEMESTRE", value: "sem", sortable: true, class: 'my-header-style'  },
            { text: "CREDITOS", value: "credi", sortable: true , class: 'my-header-style' },
            { text: "CODIGO", value: "codmt", sortable: true, class: 'my-header-style'  },
            { text: "MATERIA", value: "mat", sortable: false, class: 'my-header-style'  },
            { text: "PARALELO", value: "par", sortable: false, class: 'my-header-style'  },
            { text: "RECURSADA", value: "rescurs", sortable: true, class: 'my-header-style' },
            { text: "ESTADO", value: "estcv", sortable: true, class: 'my-header-style' },
            { text: "RESOLUCION", value: "rescv", sortable: true, class: 'my-header-style' },
            { text: "OPCIONES", value: "actions", sortable: false },
    
          ],
          headersPagos: [
    
            { text: "GESTION", value: "nomges", sortable: true, class: 'my-header-style'  },
            { text: "CONCEPTO", value: "nomits", sortable: true, class: 'my-header-style'  },
            { text: "FACTURA", value: "factura", sortable: false , class: 'my-header-style' },
            { text: "MONTO", value: "monto", sortable: true , class: 'my-header-style' },
            { text: "FECHA", value: "fec", sortable: true, class: 'my-header-style'  },
            { text: "OPCIONES", value: "actions", sortable: false }
  
          ],
          headersPagoslist: [
    
            { text: "GESTION", value: "nomges", sortable: true , class: 'my-header-style'  },
            { text: "CONCEPTO", value: "nomits", sortable: true, class: 'my-header-style'  },
            { text: "FACTURA", value: "factura", sortable: false , class: 'my-header-style' },
            { text: "MONTO", value: "monto", sortable: true, class: 'my-header-style'  },
            { text: "FECHA", value: "fec", sortable: true , class: 'my-header-style' },
            
  
          ],
  
          headersPagostransferidos: [
    
            { text: "GESTION", value: "nomges", sortable: true , class: 'my-header-style' },
            { text: "CONCEPTO", value: "nomits", sortable: true , class: 'my-header-style' },
            { text: "FACTURA", value: "factura", sortable: false , class: 'my-header-style' },
            { text: "MONTO", value: "monto", sortable: true, class: 'my-header-style'  },
            { text: "FECHA", value: "fec", sortable: true },
          ],
    
          datosPagos:[],
          datosPagostransferidos:[],
          user: {},
          usuario: "",
          id_sede: "",
          nomus: "",
          patus: "",
          matus: "",
          id_documento: "",
          datosTipoDocumento: "",
          nuevoplaneco:"",
          id_tipo_documento: "",
          tipo_doc_nom: "",
          iddocseg2: "",
          documento2: "",
          nivelMinimo: "",
          nuevaResolucion:"",
          nuevaObservacion:"",
          select: "",
          selectAño: "",
          selectCiudad: "",
          selectPais: "",
          tituloObtenido: "",
          institucion: "",
          idnuevoplaneco:"",
          areaEstudios: null,
          añoObtencion: "",
          cargaHoraria: null,
          datosPais: [],
          datosCiudad: [],
          datosplanespagos:[],
          tpFormacion: "",
          datosFormacionAcademica: [],
          selectPais1: "",
          act: 0,
          idForm: "",
          botonAct: 0,
          iddeuconact:"",
          conceptoact:"",
          deudaact :"",
          descuento:"",
          iditemtrans:"",
          conceptotrans:"",
          deudatrans:"",
          gestiontrans:"",
          facturatrans:"",
          gestiontrans :"",
          idGestiontrans :"",
          addtransferencia:"",
          paralelodel:"",
          idnotadel:"",
          idmatdel:"",
    
          flag: 1,
  
          updObsModal:false,
          seguroModal:false,
          seguroNoInscrip:false,
          id_baja_academica:"",
          id_estudiante_beca:"",
          cateobs:"",
          resolobs:"",
          obs:"",
          f_reg:"",
          f_resol:"",
          nuevaresolobs:"",
          nuevaobs:"",
          gestioninicial:"",
          idGestioninicial:"",
          gestionfin:"",
          idGestionfin:"",
    
        };
      },
      created: function () {
        this.user = JSON.parse(sessionStorage.getItem("session"));
        this.usuario = this.user.personal;
        this.id_sede = this.user.id_sede;
        this.sede = this.user.sede;
        this.nomus = this.user.nombres + " " + this.user.paterno + " " + this.user.materno;
    
    
    
      },
      computed: {},
      components: {
        VueHtml2pdf,
    
      },
    
      methods: {
        getColor1(estado1) {
              if (estado1 == '0') return 'green'
             else if (estado1 >  0) return 'red'
             
          },
        encontrarMinimoNivel() {
          for (let i = 0; i < this.datosOfertaMaterias.length; i++) {
            this.datosOfertaMateriasNivel.push(this.datosOfertaMaterias[i].idni);
          }
          this.nivelMinimo = Math.min.apply(null, this.datosOfertaMateriasNivel);
    
          if (this.idNivel <= this.nivelMinimo) {
            this.listarDocumento(this.unicodigo);
          } else {
            //console.log("seleccione nivel mas bajo");
            this.snackbarError3 = true;
          }
    
    
          //console.log(this.nivelMinimo);
          // console.log(this.datosOfertaMateriasNivel);
          this.datosOfertaMateriasNivel = [];
        },
        encontrarNivelAltoGrupoPreinscritos() {
          for (let i = 0; i < this.datosGruposPreInscripcion.length; i++) {
            this.datosNivelesPreinscritos.push(this.datosGruposPreInscripcion[i].idnv);
          }
          this.nivelMaximoPreInscrito = Math.max.apply(null, this.datosNivelesPreinscritos);
    
          if (this.idNivel == this.nivelMaximoPreInscrito) {
            this.verificarQuitarMateria();
          } else {
            //console.log("seleccione nivel mas bajo");
            this.snackbarError4 = true;
          }
    
    
          //console.log(this.nivelMinimo);
          // console.log(this.datosOfertaMateriasNivel);
          this.datosNivelesPreinscritos = [];
        },
        verificarDocumentos() {
    
    
          this.hoy = new Date();
    
          for (let i = 0; i < this.datosDocumentos.length; i++) {
            this.fechaEntrega = new Date(this.datosDocumentos[i].fpl);
    
    
            if (this.datosDocumentos[i].estado == 'PENDIENTE') {
              if (this.hoy.getTime() <= this.fechaEntrega.getTime()) {
    
                this.verificarTipoGrupo();
              } else {
                this.showDocumento();
                this.snackbarError5 = true;
    
              }
    
            } else {
              this.verificarTipoGrupo();
            }
          }
        },
        limpiarApell() {
          this.pat = "";
          this.mat = "";
          this.uniest = "";
        },
        aumentarEspacios() {
          if (this.pat != "" && this.mat == "") {
            this.mat = " ";
          } else {
            if (this.pat == "" && this.mat != "") {
              this.pat = " ";
            } else {
    
            }
          }
        },
        extraerCantMateriasTomadasEst() {
    
    
          this.cantidadActualMaterias = this.datosCantMateriasEst[0].cantmat;
          //console.log(this.cantidadActualMaterias);   
    
        },
    
    
        getColor(insc) {
          if (insc == 'LIBRE') return 'green'
          else return '#868582'
        },
        getColorKardex(insc) {
          if (insc == 'APROBADO') return 'green'
          else return 'red'
        },
        getColorKardexpar(insc) {
          if (insc == 'CONVALIDADO') return '#F57C00'
          else if (insc == 'PRECONVALIDADO') return '#F57C00'
          else return '#0288D1'
        },
  
        getColorGrupos(insc) {
          if (insc == 'TEORICO') return 'light-blue accent-2'
          else return 'orange accent-2'
        },
      
    
    
        async listarDocumento(unicodigo) {
          let me = this;
          await axios
            .get("/estudiante/buscadepen/" + this.unicodigo)
            .then(function (response) {
              if (response.data.resultado == null) {
                me.datosDocumentos = [];
                me.verificarTipoGrupo();
    
              } else {
    
    
                me.datosDocumentos = response.data.resultado;
                me.verificarDocumentos();
              }
            })
            .catch(function (error) {
    
            });
        },
    
    
    
        
     

       
        
       
    
    
        validate() {
          this.$refs.form.validate();
        },
        reset() {
          this.$refs.form.reset();
        },
        resetValidation() {
          this.$refs.form.resetValidation();
        },
        change(event) {
          let val = event.target.value.trim();
          // Solo puede ser un entero positivo o vacío, el regular se puede modificar según las necesidades
          //item = e.target.value.replace(/[^\d]/g,'')
          if (/^[1-9]\d*$|^$/.test(val)) {
            this.oldNum = val;
          } else {
            event.target.value = this.oldNum;
          }
        },
    
        buscarEstudiante() {
          //this.aumentarEspacios();
         
          if (this.uniest != "") {
            this.listarEstudianteUnicod(this.uniest, this.id_sede);
          } else {
            this.listarEstudiante(this.pat, this.mat,this.nomest, this.id_sede);
          }
        },
    
        
        showBuscarEstudiante() {
          //this.limpiar();
          this.elModal = true;
    
        },
        showHorario() {
          //this.limpiar();
    
          this.horarioModal = true;
          //this.listarCarrera(this.unicodigo,this.id_sede);
        },
        closeHorario() {
          this.horarioModal = false;
        },
        showitemscuotas() {
    
          //this.listarDocumento(this.unicodigo);
          this.itemscuotasModal = true;
          this.listaritems();
    
        },
        
        closeitemscuotas() {
          this.itemscuotasModal = false;
        },
        closeitemscuotasfac() {
          this.itemscuotasfacturaModal = false;
        },
        showBuscarbeca() {
          //this.limpiar();
          this.becaModal = true;
          this.listartipobecas(this.id_sede);
    
        },
       
        seleccionarBeca(item) {
          this.idbec = item.idbeca;
          this.descripbeca = item.descip;
          this.becaModal = false;
    
        },
        closebeca() {
          //this.limpiar();
          this.becaModal = false;
    
        },
        selectDeleteBeca(item) {
          this.idbecdel = item.ideb
          this.confirDeleteBecaModal = true;
        },
        
    
        savenewCobro(){
          this.verifyitemestud(this.unicodigo,this.id_sede,this.idGestion,this.idPlanestudio,this.idItem);
          
        },
        async verifyitemestud(unicodigo,id_sede,idGestion,idPlanestudio,idItem){
        let me = this;
        await axios .get("/pagos/verifitemdeuest/" + this.unicodigo + "," + this.id_sede+ "," + this.idGestion + "," + this.idPlanestudio + "," + this.idItem)
        .then (function(response){
             
          if (response.data.resultado == null) {
                 //me.duplicado=0;
                 if (me.montoitem>0){
                    me.savenewitemestudeuda(me.unicodigo,me.id_sede,me.idGestion,me.idPlanestudio,me.idItem,me.montoitem,me.idPlanEconomico);
                 }else {
                  //console.log(response.data.message);
                  me.mensajeSnackbar = "EL MONTO DEBE SER MAYOR A 0!!!";
                  me.snackbarOK = true;
                  }
                  
              } else {
                  //console.log(response.data.message);
                  me.mensajeSnackbar = "EL ITEM YA ESTA REGISTRADO!!!";
                  me.snackbarOK = true;
              }
              
        })
        .catch(function(error){
              console.log(error.response.data.message);
        });
  },
  
       
        closeGestionfin() {
          this.gestionfinModal = false;
        },
        seleccionarGestionfin(item) {
          this.gestionfin = item.nom;
          this.idGestionfin = item.id_gestion;
        },
        async listarGestionfin() {
          let me = this;
          await axios
            .get("/pagos/buscagestiondar/")
            .then(function (response) {
              if (response.data.resultado == null) {
                me.datosGestionfin = [];
    
              } else {
    
                me.datosGestionfin = response.data.resultado;
              }
            })
            .catch(function (error) {
    
            });
        },

        showGestion() {
          //this.limpiar();
          this.gestionModal = true;
          this.listarGestion();
        },
        closeGestion() {
          this.gestionModal = false;
        },
        showGestiontrans() {
          //this.limpiar();
          this.gestiontransModal = true;
          this.listartransGestion();
        },
        closeGestiontrans() {
          this.gestiontransModal = false;
        },
        seleccionarItemtranseferir(item){
          this.idgtrans = item.idge;
          this.iditemtrans = item.idits;
          this.conceptotrans = item.nomits;
          this.deudatrans = item.monto;
          this.gestiontrans = item.nomges;
          this.facturatrans = item.factura;
  
        },
    
        seleccionarItemactmon(item) {
    
          this.detalleModal = true;
          this.iddeuconact = item.iddc;
          this.conceptoact = item.item;
          this.deudaact = item.deuda;
          this.descuento = item.montodes;
    
          //this.listarGruposInscripcion(this.idMateria, this.idTurno, this.idGestion);
        },
        seleccionarItemdel(item) {
    
          this.EliminaritemModal = true;
          this.iddeuconact = item.iddc;
          this.conceptoact = item.item;
          this.deudaact = item.deuda;
  
          //this.listarGruposInscripcion(this.idMateria, this.idTurno, this.idGestion);
        },
        closeeliminar(){
          this.EliminaritemModal = false;
        },
        
        closeDetalleInscripcion() {
          this.detalleModal = false;
        },
  
        actualizarmontoitem(){
          this.actualizardeuda(this.iddeuconact,this.deudaact,this.descuento);
          this.detalleModal = false;
        },
        async actualizardeuda(iddeuconact, deudaact,descuento) {
          let me = this;
    
          //let me=this;
          await axios
            .post(
              "/pagos/upddeudaitemest/" +
              this.iddeuconact +
              "," +
              this.deudaact +
              "," +
              this.descuento 
  
  
            )
            .then(function (response) {
    
              me.snackbarOK = true;
              me.mensajeSnackbar = response.data.message;
              me.listarDeudaest(me.unicodigo,me.idPlanestudio,me.idGestion,me.id_sede);
              me.listarObserest(me.unicodigo,me.idGestion,me.id_sede);
            })
            .catch(function (error) {
              me.snackbarError = true;
              me.mensajeSnackbar = response.data.message;
            });
        },
        eliminarmontoitem(){
          this.eliminardeuda(this.iddeuconact);
          this.EliminaritemModal = false;
        },
        async eliminardeuda(iddeuconact) {
          let me = this;
    
          //let me=this;
          await axios
            .post(
              "/pagos/deldeudaitemest/" +
              this.iddeuconact
            )
            .then(function (response) {
    
              me.snackbarOK = true;
              me.mensajeSnackbar = response.data.message;
              me.listarDeudaest(me.unicodigo,me.idPlanestudio,me.idGestion,me.id_sede);
              me.listarObserest(me.unicodigo,me.idGestion,me.id_sede);
            })
            .catch(function (error) {
              me.snackbarError = true;
              me.mensajeSnackbar = response.data.message;
            });
        },
        showObservacion() {
    
          this.observacionModal = true;
        
        },
        closeObservacion() {
          this.observacionModal = false;
        },
    
    
        limpiar() {
          this.datosDeuda=[];
          this.datosBecas=[];
          this.datosTomamateria=[];
          this.datosPagos=[];
          this.datosPagos=[];
          this.datosDeudaObservacion=[];
          this.limpiarobserv3();
          this.limpiarobserv1();
          this.limpiarobserv();
          this.limpiarobservcambioplan();
        },
    
        addMateriaInscripcion() {
          this.añadirMateriaInscripcion(
            this.unicodigo,
            this.id_sede,
            this.idUsuario,
            this.idTurno,
            this.idCarrera,
            this.idGestion,
            this.idPlanEconomico,
    
          );
          this.botonAct = 0;
        },
        saveObservacion(){
           this.saveObservacionestudiantedeuda(this.unicodigo,this.id_sede,this.idGestion,this.idPlanestudio);
           this.observacionModal = false;
  
        },
      
   
  
        /* verificarExisteMateriaPractica() {
       
           this.verificarExsiteMatPractica(this.idPlanestudio, this.idGestion, this.idMateria);
       
         },*/
  
  
        
    
    
        deleteItem(item) {
          this.editedIndex = item.nitf;
          this.editedItem = item.nitf;
          // this.dialogDelete = true
        },
    
    
        close() {
          this.elModal = false;
        },
        showCompromiso() {
          this.compromisoModal = true;
    
        },
        closeCompromiso() {
          this.compromisoModal = false;
        },
        showKardex() {
          this.kardexModal = true;
    
        },
        closeKardex() {
          this.kardexModal = false;
        },
       
        closeRegcompromiso() {
          this.regcompromisoModal = false;
        },
        realizarcompromiso() {
          this.regcompromisoModal = false;
          this.registrarcompromisodoc(this.iddocseg1, this.fplazo);
    
    
          // this.registrarcobrodetalle(this.id_docente)
        },
  
          // REGISTRO DE TRANSFERENCIAS
          registrarBaja1(){
  
          //this.nuevaResolucion = this.resolucion.replaceAll("/", ".");
          //this.nuevaObservacion=this.observacion.replaceAll("/", ".");
          this.nuevaResoluciontrans = this.replaceSpecialCharacters(this.resoluciontrans);
          this.nuevaObservaciontrans = this.replaceSpecialCharacters(this.observaciontrans);
          this.añadirtransferencia();
  
          },
          async añadirtransferencia(
       
       ) {
         let me = this;
   
         //let me=this;
         await axios
           .post(
             "/pagos/addtransferencia/" +
               this.unicodigo +
               "," +
               this.id_sede +
               "," +
               this.idGestion +
               "," +
               this.idPlanestudio +
               "," +
               this.fechaResoluciontrans +
               "," +
               this.referencia1 +
               "," +
               this.nuevaObservaciontrans +
               "," +
               this.nuevaResoluciontrans +
               "," +
               this.idGestiontrans +
               "," +
               this.iditemtrans +
               "," +
               this.facturatrans  +
               "," +
               this.deudatrans
         
           )
           .then(function (response) {
             me.snackbarOK = true;
             me.mensajeSnackbar = response.data.message;
             me.listarpagostransferidos(me.unicodigo,me.id_sede);
             me.listarObserest(me.unicodigo,me.idGestion,me.id_sede);
             me.listarHistorialEconomico(me.unicodigo,me.id_sede);
             me.limpiarobserv1();
             //me.listarBajaAcademica();
             
           })
           .catch(function (error) {
             me.snackbarError = true;
             me.mensajeSnackbar = response.data.message;
           });
       },
       limpiarobserv1() {
          this.fechaResoluciontrans = "";
          this.referencia1 = "TRANSFERENCIA DE PAGOS";
          this.nuevaObservaciontrans = "";
          this.nuevaResoluciontrans = "";
          this.observaciontrans = "";
          this.resoluciontrans = "";
        },
  // REGISTRAR BECA
  savebecaestudiantedeuda(){
  
  //this.nuevaResolucion = this.resolucion.replaceAll("/", "*");
  this.nuevaResolucion = this.replaceSpecialCharacters(this.resolucion);
  this.nuevaObservacion = this.replaceSpecialCharacters(this.observacion);
  //this.nuevaObservacion=this.observacion.replaceAll("/", "*");
  this.regbecaestudiantedeuda();
  
  },
  async regbecaestudiantedeuda() {
          let me = this;
    
          //let me=this;
          await axios
            .post(
              "/pagos/addbecaobservar/" +
              this.unicodigo +
                "," +
                this.id_sede +
                "," +
                this.idGestion +
                "," +
                this.idPlanestudio +
                "," +
                this.fechaResolucion +
                "," +
                this.descripbeca +
                "," +
                this.nuevaObservacion+
                "," +
                this.nuevaResolucion +
              "," +
              this.pordesbec +
              "," +
              this.montodesbec +
              "," +
              this.idbec  
  
            )
            .then(function (response) {
    
              me.snackbarOK = true;
              me.mensajeSnackbar = response.data.message;
              me.listarObserest(me.unicodigo,me.idGestion,me.id_sede);
              me.listarBecasest(me.unicodigo,me.id_sede,me.idGestion,me.idPlanestudio);
              me.limpiarobserv3();
            })
            .catch(function (error) {
              me.snackbarError = true;
              me.mensajeSnackbar = response.data.message;
            });
        },
        replaceSpecialCharacters(text) {
      // Reemplaza los caracteres especiales por códigos únicos
      return text
          .replace(/\//g, '__SLASH__')
          .replace(/%/g, '__PERCENT__')
          .replace(/\$/g, '__DOLLAR__')
          .replace(/,/g, '__COMMA__');
  },
        limpiarobserv3() {
          this.fechaResolucion = "";
          this.referencia1 = "TRANSFERENCIA DE PAGOS";
          this.observacion="";
          this.nuevaObservacion = "";
          this.resolucion="";
          this.nuevaResolucion = "";
          this.observacion = "";
          this.descripbeca = "";
          this.pordesbec="";
          this.montodesbec="";
        },
        // PLANES DE PAGO 
        showBuscarplanpago() {
          //this.limpiar();
          this.planespagosModal = true;
          this.listarplanesdepago(this.id_sede);
    
        },
        async listarplanesdepago(id_sede) {
          let me = this;
          await axios
            .get("/pagos/listarPlanesdepagodar/" +  this.id_sede
            )
            .then(function (response) {
              if (response.data.resultado == null) {
                me.datosplanespagos = [];
                me.snackbarOK = true;
                me.mensajeSnackbar = response.data.message;
              } else {
                me.datosplanespagos = response.data.resultado;
    
                //me.espacioVerificado();
              }
            })
            .catch(function (error) {
            });
        },
        seleccionarPlaneco(item) {
          this.idnuevoplaneco = item.idplan;
          this.descripnuevoplaneco = item.nom;
          this.planespagosModal = false;
    
        },
        closeBuscarplanpago() {
          //this.limpiar();
          this.planespagosModal = false;
    
        },
  // OBSERVACIONES VARIAS
        registrarBajacontraseña(){
            let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
         //   let password = "P@ssw0rd";
             let resultadopass = regex.test(this.npwd);
           // console.log(resultadopass);
            if (resultadopass  == true)
            {
                this.regnpwd(this.usuario,this.pwd,this.npwd,this.id_sede);
              //  this.snackbarOK = true;
               // this.mensajeSnackbar = "LA CONTRASEÑA CUMPLE";

            }
            else 
            {
                this.normasModal= true ;
                //this.snackbarOK = true;
                //this.mensajeSnackbar = "LA CONTRASEÑA NO CUMPLE";
            }
  
       // this.nuevaResolucionobs = this.replaceSpecialCharacters(this.resolucionobs);
       // this.nuevaObservacionobs = this.replaceSpecialCharacters(this.observacionobs);
  
       // this.añadirBajaAcademica();
  
        },
        async regnpwd(usuario,pwd,npwd,id_sede) {
          let me = this;

          //let me=this;
          await axios
              .post("/estudiante/updpss/" + this.usuario + "," + this.pwd + "," + this.npwd + "," + this.id_sede )
              .then(function (response) {
                  
                  me.mensajeSnackbar = response.data.message[0].pwdupdateest;
                  me.snackbarOK = true;
                //  me.salir();
                  
              })
              .catch(function (error) {
                  me.mensajeSnackbar = response.data.message;
                  me.snackbarOK = true;
                  console.log(error.response.data.message);
              });
        },
         salir(){
          this.rl = "";
        this.us = "";
        this.sd = "";
           sessionStorage.clear();
           this.user={};
            this.$router.push("/login");
         },
        async añadirBajaAcademica(
       
        ) {
          let me = this;
    
          //let me=this;
          await axios
          .post(
              "/pagos/addobservar/" +
                this.unicodigo +
                "," +
                this.id_sede +
                "," +
                this.idGestion +
                "," +
                this.idPlanestudio +
                "," +
                this.fechaResolucionobs +
                "," +
                this.referencia +
                "," +
                this.nuevaObservacionobs+
                "," +
                this.nuevaResolucionobs
            )
            .then(function (response) {
              me.snackbarOK = true;
              me.mensajeSnackbar = response.data.message;
              me.listarObserest(me.unicodigo,me.idGestion,me.id_sede);
              me.limpiarobserv();
              //me.listarpagostransferidos(me.unicodigo,me.id_sede)
              //me.listarBajaAcademica();
              
            })
            .catch(function (error) {
              me.snackbarError = true;
              me.mensajeSnackbar = response.data.message;
            });
        },
        limpiarobserv() {
          this.fechaResolucionobs = "";
          this.referencia = "OBSERVACION";
          this.nuevaResolucionobs = "";
          this.nuevaObservacionobs = "";
          this.observacionobs = "";
          this.resolucionobs = "";
        },
        // OBSERVACIONES VARIAS
        registrarnuevoplaneco(){
  
  //this.nuevaResolucion = this.resolucion.replaceAll("/", ".");
  //this.nuevaObservacion=this.observacion.replaceAll("/", ".");
  this.nuevaResolucioncamb = this.replaceSpecialCharacters(this.resolucioncamb);
  this.nuevaObservacioncamb = this.replaceSpecialCharacters(this.observacioncamb);
  this.añadirnuevoplaneco();
  
  },
  async añadirnuevoplaneco(
  
  ) {
    let me = this;
  
    //let me=this;
    await axios
    .post(
        "/pagos/addcambioplanecono/" +
          this.unicodigo +
          "," +
          this.id_sede +
          "," +
          this.idGestion +
          "," +
          this.idPlanestudio +
          "," +
          this.fechaResolucioncamb +
          "," +
          this.referenciacpp +
          "," +
          this.nuevaObservacioncamb+
          "," +
          this.nuevaResolucioncamb 
          +","+
          this.idnuevoplaneco
      )
      .then(function (response) {
        me.snackbarOK = true;
        me.mensajeSnackbar = response.data.message;
        me.listarObserest(me.unicodigo,me.idGestion,me.id_sede);
        me.listarDeudaest(me.unicodigo,me.idPlanestudio,me.idGestion,me.id_sede);
        me.limpiarobservcambioplan();
        me.listarPlanEcoEst();
        //me.listarpagostransferidos(me.unicodigo,me.id_sede)
        //me.listarBajaAcademica();
        
      })
      .catch(function (error) {
        me.snackbarError = true;
        me.mensajeSnackbar = response.data.message;
      });
  },
  limpiarobservcambioplan() {
    this.fechaResolucioncamb = "";
    this.nuevaObservacioncamb = "";
    this.nuevaResolucioncamb = "";
    this.observacioncamb = "";
    this.resolucioncamb = "";
    this.descripnuevoplaneco="";
  },
  //***********************
        async listarHistorialEconomico(unicodigo, id_sede) {
        let me = this;
        await axios
          .get(
            "/pagos/listarpagosest2/" +
              this.unicodigo +
              "," +
              this.id_sede
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosPagos = [];
            } else {
              me.datosPagos = response.data.resultado;
            }
          })
          .catch(function (error) {});
      },
      async listarpagostransferidos(unicodigo, id_sede) {
        let me = this;
        await axios
          .get(
            "/pagos/listartranspagosest/" +
              this.unicodigo +
              "," +
              this.id_sede
           )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosPagostransferidos = [];
            } else {
              me.datosPagostransferidos = response.data.resultado;
            }
          })
          .catch(function (error) {});
      },
      editarObservacion(item){
        this.id_baja_academica=item.id_baja_aca;
        this.cateobs = item.categ;
        this.resolobs = item.resol;
        this.obs = item.observ;
        this.f_reg = item.registrado;
        this.f_resol=item.fecha
        this.id_estudiante_beca=item.id_obsbeca;
        console.log("id_obs_beca 1 -> " + this.id_estudiante_beca);
        if(this.id_estudiante_beca==null){
          this.id_estudiante_beca=0
          console.log("id_obs_beca 2 -> " + this.id_estudiante_beca);
  
        }
        this.updObsModal= true;
      },
      eliminarObservacion(item){
        this.id_baja_academica=item.id_baja_aca;
        this.id_estudiante_beca=item.id_obsbeca;
        console.log("id_obs_beca eliminar 1 -> " + this.id_estudiante_beca);
        if(this.id_estudiante_beca==null){
          this.id_estudiante_beca=0
          console.log("id_obs_beca eliminar 2 -> " + this.id_estudiante_beca);
        }
        this.seguroModal= true;
      },
      async eliminarObs(){
        let me = this;
    
          //let me=this;
          await axios
            .post(
              "/estudiante/delobservaciones/" +
              this.unicodigo +
              "," +
          this.id_sede +
          "," +
          this.idGestion +
          "," +
          this.id_baja_academica+
          ","+
          this.id_estudiante_beca
            )
            .then(function (response) {
    
              me.snackbarOK = true;
              me.mensajeSnackbar = response.data.message;
              me.listarObserest();
              me.listarBecasest();
              me.closeDeldObs();
    
            })
            .catch(function (error) {
              me.snackbarError = true;
              me.mensajeSnackbar = response.data.message;
            });
  
      },
  
  
      async registrarUpdObs(){
        this.nuevaresolobs = this.replaceSpecialCharacters(this.resolobs);
        this.nuevaobs = this.replaceSpecialCharacters(this.obs);
        let me = this;
  
    await axios
    .post(
        "/estudiante/updobservaciones/" +
          this.unicodigo +
          "," +
          this.id_sede +
          "," +
          this.idGestion +
          "," +
          this.id_baja_academica+
          ","+
          this.nuevaresolobs +
          ","+
          this.f_resol +
          ","+
          this.nuevaobs +
          ","+
          this.id_estudiante_beca
      )
      .then(function (response) {
        me.snackbarOK = true;
        me.mensajeSnackbar = response.data.message;
        me.listarObserest();
        me.listarBecasest();
        me.closeUpdObs();
      })
      .catch(function (error) {
        me.snackbarError = true;
        me.mensajeSnackbar = response.data.message;
      });
      },
      closeUpdObs(){
        this.updObsModal= false;
      },
      closeDeldObs(){
        this.seguroModal= false;
      },
      volverrecursada(item) {
        this.idgrupo = item.idgru;
        this.idmateria = item.idmat;
  
        //this.unicodigo = item.unicod;
        //this.idPlanestudio = item.idplan;
        //this.id_sede
        //this.idGestion = item.id_gestion;
  
        this.volverrecursadaguardar();
      
      },
      // TOMA DE MATERIAS 
      showdeltoma() {
          // this.limpiar();
          this.EliminartomaModal = true;
        },
        closedeltoma() {
          this.EliminartomaModal = false;
        },
        eliminartomamaterias() {
          this.deletetoma(this.unicodigo,this.idGestion,this.id_sede,this.idPlanestudio,this.usuario);
        },
        
        async deletetoma(unicodigo,idGestion,id_sede,idPlanestudio,usuario) {
        let me = this;
  
        await axios
          .post(
            "/pagos/deltoma/" + this.unicodigo + "," + this.idGestion + "," + this.id_sede + "," + this.idPlanestudio +","+this.usuario)
          .then(function (response) {
            me.mensajeSnackbar = response.data.message;
            me.snackbarOK = true;
            me.listarTomaest(me.unicodigo,me.idGestion,me.id_sede,me.idPlanestudio);
            me.EliminartomaModal = false;
            //me.listaritemcuotaest(me.unicodigo,me.idPlanestudio,me.idGestion,me.id_sede);
            
            
            //me.extraerPlanEstudio(); -- NO SE SAVE QUE HACE !!!!
           // me.extraerUnicodigo(); 
            
  
          })
          .catch(function (error) {
            me.snackbarError = true;
  
  
  
          });
          
          
  
  
      },
      //ELIMINAR TOMA INDIVIDUAL
  
      showdeltomaind(item) {
          this.paralelodel = item.par;
          this.idnotadel = item.idnt;
          this.idmatdel = item.idmat
          // this.limpiar();
          this.EliminartomaindividualModal = true;
        },
        closedeltomaind() {
          this.paralelodel = "";
          this.idnotadel = "";
          this.idmatdel = "";
          this.EliminartomaindividualModal = false;
        },
        eliminartomamateriasind() {
          this.deletetomaind(this.unicodigo,this.idGestion,this.id_sede,this.idPlanestudio,this.usuario,this.paralelodel,this.idnotadel,this.idmatdel);
        },
        
        async deletetomaind(unicodigo,idGestion,id_sede,idPlanestudio,usuario,paralelodel,idnotadel,idmatdel) {
        let me = this;
  
        await axios
          .post(
            "/pagos/deltomaind/" + this.unicodigo + "," + this.idGestion + "," + this.id_sede + "," + this.idPlanestudio +","+this.usuario+","+this.paralelodel+","+this.idnotadel+","+this.idmatdel)
          .then(function (response) {
            me.mensajeSnackbar = response.data.message;
            me.snackbarOK = true;
            me.listarTomaest(me.unicodigo,me.idGestion,me.id_sede,me.idPlanestudio);
            me.EliminartomaindividualModal = false;
            //me.listaritemcuotaest(me.unicodigo,me.idPlanestudio,me.idGestion,me.id_sede);
            
            
            //me.extraerPlanEstudio(); -- NO SE SAVE QUE HACE !!!!
           // me.extraerUnicodigo(); 
            
  
          })
          .catch(function (error) {
            me.snackbarError = true;
  
  
  
          });
          
          
  
  
      },
  
  
      showdesacttoma() {
          // this.limpiar();
          this.desacttomaModal = true;
        },
        closedesacttoma() {
          this.desacttomaModal = false;
        },
        desactivartomamaterias() {
          this.desactivartoma(this.unicodigo,this.idGestion,this.id_sede,this.idPlanestudio);
        },
        async desactivartoma(unicodigo,idGestion,id_sede,idPlanestudio) {
        let me = this;
  
        await axios
          .post(
            "/pagos/desactivotoma/" + this.unicodigo + "," + this.idGestion + "," + this.id_sede + "," + this.idPlanestudio)
          .then(function (response) {
            me.mensajeSnackbar = response.data.message;
            me.snackbarOK = true;
            me.listarTomaest(me.unicodigo,me.idGestion,me.id_sede,me.idPlanestudio);
            me.desacttomaModal = false;
            //me.listaritemcuotaest(me.unicodigo,me.idPlanestudio,me.idGestion,me.id_sede);
            
            
            //me.extraerPlanEstudio(); -- NO SE SAVE QUE HACE !!!!
           // me.extraerUnicodigo(); 
            
  
          })
          .catch(function (error) {
            me.snackbarError = true;
  
  
  
          });
  
  
      },
       
        activartomamaterias() {
          this.activartoma(this.unicodigo,this.idGestion,this.id_sede,this.idPlanestudio);
        },
        async activartoma(unicodigo,idGestion,id_sede,idPlanestudio) {
        let me = this;
  
        await axios
          .post(
            "/pagos/activotoma/" + this.unicodigo + "," + this.idGestion + "," + this.id_sede + "," + this.idPlanestudio)
          .then(function (response) {
            me.mensajeSnackbar = response.data.message;
            me.snackbarOK = true;
            me.listarTomaest(me.unicodigo,me.idGestion,me.id_sede,me.idPlanestudio);
            me.acttomaModal = false;
            //me.listaritemcuotaest(me.unicodigo,me.idPlanestudio,me.idGestion,me.id_sede);
            
            
            //me.extraerPlanEstudio(); -- NO SE SAVE QUE HACE !!!!
           // me.extraerUnicodigo(); 
            
  
          })
          .catch(function (error) {
            me.snackbarError = true;
  
  
  
          });
  
  
      },
      async volverrecursadaguardar() {
    let me = this;
  
    try {
      const response = await axios.post(
        "/pagos/volverrecursada/" +
          this.unicodigo +
          "," +
          this.idPlanestudio +
          "," +
          this.idmateria +
          "," +
          this.id_sede +
          "," +
          this.idGestion +
          "," +
          this.idgrupo +
          "," +
          this.idPlanEconomico
      );
  
      me.mensajeSnackbar = response.data.message;
      me.snackbarOK = true;
      me.listarBecasest(me.unicodigo,me.id_sede,me.idGestion,me.idPlanestudio);
      me.listarDeudaest(me.unicodigo,me.idPlanestudio,me.idGestion,me.id_sede);
      me.listarTomaest(me.unicodigo,me.idGestion,me.id_sede,me.idPlanestudio);
      me.listarObserest(me.unicodigo,me.idGestion,me.id_sede);
  
    } catch (error) {
      me.snackbarError = true;
      me.mensajeSnackbar = error.response?.data?.message || "Ocurrió un error";
    }
  }
  ,
  
        async listarvigeciabacest(unicodigo, id_sede) {
    
          let me = this;
          await axios
            .get("/pagos/listarvigebacest/" + this.unicodigo + "," + this.id_sede)
            .then(function (response) {
              if (response.data.resultado == null) {
                me.datosvigenciaBac = [];
               // me.limpiarApell();
                me.snackbarOK = true;
                me.mensajeSnackbar = response.data.message;
    
              } else {
    
                me.datosvigenciaBac = response.data.resultado;
               // me.limpiarApell();
              }
            })
            .catch(function (error) {
    
            });
    
        },
       
        closedeltoma() {
          this.normasModal = false;
        },
  async savefactura() {
    
    if ( (this.numfactura !="")&&(this.idItemfac!="")&&( this.fechafac!="")){
    let me = this;
    try {
      const response = await axios.post(
        "/pagos/addfacturamanual/" +
          this.unicodigo +
          "," +
          this.fechafac +
          "," +
          this.numfactura +
          "," +
          this.idItemfac +
          "," +
          this.idGestion +
          "," +
          this.id_sede +
          "," +
          this.montoitemfac
      );
  
      me.mensajeSnackbar = response.data.message[0].pagos_add_facturamanual;
      me.snackbarOK = true;
      this.listarHistorialEconomico(this.unicodigo,this.id_sede);
    //  me.listarBecasest(me.unicodigo,me.id_sede,me.idGestion,me.idPlanestudio);
    //  me.listarDeudaest(me.unicodigo,me.idPlanestudio,me.idGestion,me.id_sede);
    //  me.listarTomaest(me.unicodigo,me.idGestion,me.id_sede,me.idPlanestudio);
    ///  me.listarObserest(me.unicodigo,me.idGestion,me.id_sede);
  
    } catch (error) {
      me.mensajeSnackbar = response.data.message;
      me.snackbarOK = true;
    }
  }
  else {
    this.mensajeSnackbar = "DEBE LLENAR TODOS LOS CAMPOS :(";
    this.snackbarOK = true;
  }
  }
  ,
      closeIns(){
        this.seguroNoInscrip= false;
      },
  
    
    
    
    
      },
    };
    </script>
    <style>
    .page-number {
      position: absolute;
      bottom: 10px;
      right: 10px;
      font-size: 10px;
      color: #333;
    }
    .my-header-style {
      background: #F0F4C3;
     
    }
    .img12 {
      margin: 10px;
      border-radius: 20%;
      box-shadow: 0px 0px 9px 4px #EE680B;
      animation: glow 1.5s linear infinite alternate;
    }
    
    @keyframes glow{
      to {
        box-shadow: 0px 0px 10px 10px #002245;
      }
    }
    </style>